import { render, staticRenderFns } from "./StatusNotificationTable.vue?vue&type=template&id=04440566&"
import script from "./StatusNotificationTable.vue?vue&type=script&lang=js&"
export * from "./StatusNotificationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports